// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__lCTY_","title":"AfterFrontImage_title__1MweF"};